import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component/umpire-component';
import {ItemSelectionType} from '../umpire-component-hero-generic';

export interface UmpireComponentOttHero
  extends UmpireComponent<UmpireComponentTypeEnum.OTT_HERO_MAIN> {
  events_order: EventOrder[];
  event_selections: Extract<
    ItemSelectionType,
    | ItemSelectionType.autoAll
    | ItemSelectionType.autoAllFeatured
    | ItemSelectionType.autoVod
    | ItemSelectionType.manual
  >;
}

export interface EventOrder {
  event_id: string;
  event_index: number;
}
